import { themeConfig } from 'config';
import themes from 'config/themes';
import { theme } from 'helpers/utility';
import { Map } from 'immutable';
import actions from './actions';

// Guard against stale/unknown persisted theme values (e.g. a removed theme left in localStorage):
// always resolve to a theme that actually exists in the `themes` map, falling back to atsFancy.
const resolveTheme = (name) => (name && themes[name] ? name : 'atsFancy');

const initState = new Map({
  isActivated: false,
  selectedTheme: resolveTheme(theme.get() || themeConfig.theme),
});

const themeSwitcherReducer = function (state = initState, action) {
  switch (action.type) {
    case actions.CHANGE_THEME: {
      const next = resolveTheme(action.theme);
      theme.set(next);
      return state.set('selectedTheme', next);
    }
    default:
      return state;
  }
};

export default themeSwitcherReducer;
